<template>
  <div></div>
</template>

<script>
import AuthentificationService from '@/services/authentification'
import LoaderService from '@/services/loader'

export default {
  mounted() {
    LoaderService.showLoader()
    setTimeout(function() {
      AuthentificationService.logout()
      LoaderService.hideLoader()
    }, 1000)
  }
}
</script>